import { SIGNOUT_USER_SUCCESS } from '../User/UserTypes';
import * as TYPES from './DietsTypes';

const initialState = {
  list: [],
};

export default function DietsReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  if (type === TYPES.DIET_LIST_SUCCESS) {
    return {
      ...state,
      list: payload,
    };
  } else if (type === SIGNOUT_USER_SUCCESS) {
    return initialState;
  }
  return state;
}
